import ErrorComponent from 'Components/ErrorComponent';
import { checkValidArray, errResponse, handleServerResponse } from 'GenericForms/Helper';
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query';
import { Row, Col, Button, Card, CardHeader, CardBody, Label, CardFooter } from 'reactstrap'
import { queryKeyes } from 'shared/queryKeys';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import Select from "react-select";
import { customStyle } from 'shared/CommonCSS';
import { useFormik } from 'formik';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import { errorToast, successToast } from 'Components/Toasts';
import apiGlobal, { apiMedia } from 'global/api.global';
import { queryClient } from 'react-query/queryClient';
import DeletePopOver from 'Components/DeletePopOver';
import ReportingFileUpload from 'Components/ReportingFileUpload';
import * as Yup from "yup";
import env from 'environment_system/env_system';
import ErrorTooltip from 'Components/ErrorTooltip';
import { commonValidationMessages } from 'Components/ValidationErrorMessages';
import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentReportFilesAction } from 'Store/Generic/ReportingSlice';
import FormLoading from 'Components/FormLoading';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

interface BunkeringType {
    setModalState?: (value: boolean) => void;
    modalState?: boolean;
    toggleDynamicTabs?: (value: number) => void;
    setErrorMessage?: any;
}

const BunkeringFileUpload = ({
    setModalState,
    modalState = false,
    toggleDynamicTabs,
    setErrorMessage,
}: BunkeringType) => {
    /** State variables */
    const { previousEnggTabIndex } = useEditReport();
    useDocumentTitle("BDN File Upload - ecoSAIL");
    const { ReportID, VesselID, CurrentReportFiles } = useSelector((state: RootState) => state.Reporting);
    const [count, setCount] = useState(0);
    const [fileRemoveKey, setFileRemoveKey] = useState(0);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [popOverIndex, setPopOverIndex] = useState(0);
    const [BDNFile, setBDNFile] = useState<Array<any>>([]);
    const [BDNFileRenderCount, setBDNFileRenderCount] = useState(0);
    const [deleteBunkeringObject, setDeleteBunkeringObject] = useState<any>();
    const [deleteUploadedFile, setDeleteUploadedFile] = useState<boolean>(false);
    const [batchDeleteBool, setBatchDeleteBool] = useState<boolean>(false);
    const [batchDeleteId, setBatchDeleteId] = useState<number>(0);
    const [BDNObject, setBDNObject] = useState<any>({});
    const dispatch = useDispatch();
    const BDNFileObj = checkValidArray(CurrentReportFiles?.BDN) ? CurrentReportFiles?.BDN : [];
    const [saveButtonDisableBool, setSaveButtonDisableBool] = useState<any>({});
    /** State variables end */

    /** useQueries */
    /**get the third BunkerinBDN tabel with all the bunkering this is used as the options in the droupdown  */
    const { data: BunkeringBDN, isLoading: BunkeringObjectLoading, isError: BunkeringObjectError } = useQuery(
        [queryKeyes.Bunkering.BunkeringBDN.key, ReportID],
        async () => {
            return await Get(queryKeyes.Bunkering.BunkeringBDN.url(ReportID), ReportID);
        },
        {
            enabled: true,
            staleTime: Infinity,
        }
    )
    /** Queries end */
    const getInitialValues = (): any[] => {
        let BDNArray: any[] = [];
        /**we match bdn_file (id) in BDNFileObj with BunkeringBDN
         * and take the bunkering ID from that amd store it in Bunkering []
         *  in BDNArray[].bunkering[]
         */
        if (checkValidArray(BDNFileObj) && BDNFileObj.length > 0) {
            BDNArray = BDNFileObj.map((obj: any) => {
                const matchedBunkerings = BunkeringBDN?.filter(
                    (b: any) => b?.bdn_file === obj.id
                ) || [];
                return {
                    ...obj,
                    bunkering: matchedBunkerings.map((b: any) => b.bunkering),
                    vessel_reporting_information: ReportID,
                };
            });
        } else {
            BDNArray.push({
                bdn_file: null,
                file_name: "",
                bunkering: [],
                vessel_reporting_information: ReportID,
            });
        }
        return BDNArray;
    };

    // Use useEffect to set state after initial render
    useEffect(() => {
        if (BDNFileRenderCount < 1 && BDNFileObj && BDNFileObj.length > 0) {
            let updatedBDNFile: any[] = []
            BDNFileObj.forEach((obj: any) => {
                updatedBDNFile.push({ name: obj.file_name })
            })
            setBDNFileRenderCount(BDNFileRenderCount + 1)
            setBDNFile(updatedBDNFile);
            setCount(count + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [BDNFileObj]);  // Empty dependency array to only run once when the component is mounted

    useEffect(() => {
        const hasFile = BDNFile.some((f: any) => !!f?.file);
        setSaveButtonDisableBool(hasFile);
    }, [BDNFile])

    /** BDN Upload Formik object */
    const BDNFileUploadFromik = {
        initialValues: {
            bunkering: getInitialValues(),
        },
        // Validation Schema
        validationSchema: env?.form_validation ? Yup.object().shape({
            bunkering: Yup.array().of(
                Yup.object().shape({
                    bunkering: Yup.array()
                        .when([], {
                            is: () => BDNFile.some((item: any) => item.name),
                            then: (schema) =>
                                schema.min(1, commonValidationMessages.required),
                            otherwise: (schema) => schema.nullable(),
                        })
                        .nullable()
                        .default([]),
                })
            ),
        }) : null
    }

    /** Post submit actions based on response */
    const handleResponse = (response: any) => {
        if (response.status === 201 || response.status === 200) {
            successToast("Data saved successfully!");
        } else if (response.status === 204) {
            successToast("Data deleted successfully!");
        }
    }
    /** POST request for Bunkering */
    const BunkeringFileUploadSubmit = async (values: any, actions: any) => {
        if (env?.form_validation === false && modalState === false) {
            setErrorMessage(null)
            toggleDynamicTabs(previousEnggTabIndex + 1);
        }
        const responseArray: any = [];
        const shouldProceed = values?.bunkering?.every((item: any) => item?.bunkering?.length === 0);
        const ids = BunkeringBDN?.map((item: any) => item.id);
        const postObject = {
            ...values?.bunkering[0]
        }
        postObject.bunkering = ids
        if (shouldProceed) {
            if (modalState === false) {
                setErrorMessage(null)
                toggleDynamicTabs(previousEnggTabIndex + 1);
            }
        } else {
            const areBunkeringObjectsEqual = (obj1: any, obj2: any): boolean => {
                if (!obj1 || !obj2) return false;

                const list1 = obj1.bunkering;
                const list2 = obj2.bunkering;

                if (!Array.isArray(list1) || !Array.isArray(list2)) return false;
                if (list1.length !== list2.length) return false;

                for (let i = 0; i < list1.length; i++) {
                    if (!deepEqual(list1[i], list2[i])) {
                        return false;
                    }
                }

                return true;
            }
            const deepEqual = (a: any, b: any): boolean => {
                if (a === b) return true;
                if (typeof a !== typeof b) return false;
                if (a === null || b === null) return a === b;
                if (Array.isArray(a)) {
                    if (!Array.isArray(b) || a.length !== b.length) return false;
                    return a.every((value, index) => deepEqual(value, b[index]));
                }
                if (typeof a === 'object') {
                    const keysA = Object.keys(a);
                    const keysB = Object.keys(b);
                    if (keysA.length !== keysB.length) return false;
                    return keysA.every(key => deepEqual(a[key], b[key]));
                }
                return false;
            }
            Array.isArray(values?.bunkering) && values?.bunkering?.forEach(async (bunker: any, index: number) => {
                if (areBunkeringObjectsEqual(values, bunker)) {
                    setErrorMessage(null)
                    toggleDynamicTabs(previousEnggTabIndex + 1);
                    return;
                }
                if (bunker.id) {
                    const formData = new FormData();
                    Object.keys(bunker).forEach(key => {
                        if (bunker[key] === null || undefined) return;
                        formData.append(key, bunker[key]);
                    });
                    if (BDNFile && Array.isArray(BDNFile) && BDNFile[index]?.file) {
                        formData.set('bdn_file', BDNFile[index].file)
                    }
                    responseArray.push(apiMedia.put(`/bdn_file/${bunker.id}/`, formData).then(res => {
                        if (res.status === 200) {
                            BDNFile[index] = {}
                        }
                    }));
                } else {
                    if (bunker.bunkering?.length > 0) {
                        const formData = new FormData();
                        Object.keys(bunker).forEach(key => {
                            if (values.bunkering[key] === null || undefined) return;
                            formData.append(key, bunker[key]);
                        });
                        if (BDNFile && Array.isArray(BDNFile) && BDNFile[index]?.file) {
                            formData.set('bdn_file', BDNFile[index].file)
                            responseArray.push(apiMedia.post(`/bdn_file/`, formData).then(res => {
                                if (res.status === 201) {
                                    BDNFile[index] = {}
                                }
                            }))
                        }
                    }
                }
            })
        }
        await handleServerResponse(responseArray).then(async (res: any) => {
            if (res === true) {
                await queryClient.invalidateQueries(queryKeyes.Bunkering.BunkeringBDN.key)
                await dispatch(getCurrentReportFilesAction(ReportID, VesselID))
                queryClient.invalidateQueries(queryKeyes.vessel.ViewFilesByReport.key);
                queryClient.invalidateQueries(queryKeyes.vessel.ViewFilesByVessel.key); setDeleteBunkeringObject(null);
                if (modalState) {
                    setModalState(!modalState);
                    await queryClient.invalidateQueries(queryKeyes.pagination.BDNPendingFilesPage.key);
                }
                if (env?.form_validation === true && modalState === false) {
                    setErrorMessage(null);
                    toggleDynamicTabs(previousEnggTabIndex + 1);
                }
                setCount(count + 1);
            } else {
                if (modalState === false) {
                    setErrorMessage(res)
                }
            }
        })
        actions.setSubmitting(false);
    }

    const BDNFormik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            bunkering: getInitialValues(),
        },
        validationSchema: env?.form_validation === true ? BDNFileUploadFromik.validationSchema : null,
        onSubmit: async (values, actions) => {
            actions.setSubmitting(true);
            await BunkeringFileUploadSubmit(values, actions);
            await dispatch(getCurrentReportFilesAction(ReportID, VesselID))
            actions.setSubmitting(false);
        },
    });

    /**
     * delete BDN file object
     * if BDN object is saved then send DELETE request to server
     * else delete from UI only
     * @param index current index
     */
    const deleteFileUploadItem = (lastBunkerDelete: boolean, index: number, deleteAllObjBool: boolean = false) => {
        if (deleteBunkeringObject && deleteBunkeringObject.id) {
            if (!lastBunkerDelete) {
                apiGlobal.delete(`/bdn_file/${deleteBunkeringObject.id}/`, deleteBunkeringObject).then(async res => {
                    await dispatch(getCurrentReportFilesAction(ReportID, VesselID))
                    handleResponse(res);
                    setBDNFile(prev => prev.filter((_, i) => i !== index));
                    setDeleteBunkeringObject(null)
                    setCount(count + 1);
                }).catch(err => {
                    if (errResponse.includes(err.response.status)) {
                        errorToast("Internal error occured, please contact the admin");
                    }
                });
            } else {
                let updatedObj: any = {
                    bunkering: null,
                    bdn_file: null,
                }
                apiGlobal.patch(`/bdn_file/${deleteBunkeringObject.id}/`, updatedObj).then(async res => {
                    await dispatch(getCurrentReportFilesAction(ReportID, VesselID))
                    handleResponse(res);
                    setBDNFile(prev => prev.filter((_, i) => i !== index));
                    setDeleteBunkeringObject(null)
                    setCount(count + 1);
                }).catch(err => {
                    if (errResponse.includes(err.response.status)) {
                        errorToast("Internal error occured, please contact the admin");
                    }
                });
            }
        } else {
            if (deleteAllObjBool) {
                setBDNFile(prev => prev.filter((_, i) => i !== index));
            } else {
                setBDNFile(prev =>
                    prev.map((item, i) =>
                        i === index ? {} : item
                    )
                );
            }
        }
    };

    const deleteSelectedBatch = async () => {
        let responseArray: any[] = [];
        /**we check how many batches have the same bdn_file
         * if its only one file then we delete the file
         * if more than one file then we set the bdn_file to null
         */
        const countSameBDNFile = BunkeringBDN.filter(
            (item: any) => item.bdn_file === BDNObject?.id
        ).length;
        if (countSameBDNFile === 1) {
            responseArray.push(apiGlobal.delete(`/bdn_file/${BDNObject?.id}/`));
        } else {
            responseArray.push(apiGlobal.post(`/bunkering_bdn_file/set_bdn_file_null/?id=${batchDeleteId}`));
        }
        await handleServerResponse(responseArray).then(async (res) => {
            if (res === true) {
                setCount(count + 1);
                await queryClient.invalidateQueries(queryKeyes.Bunkering.BunkeringBDN.key)
                queryClient.invalidateQueries(queryKeyes.vessel.ViewFilesByReport.key);
                queryClient.invalidateQueries(queryKeyes.vessel.ViewFilesByVessel.key); await dispatch(getCurrentReportFilesAction(ReportID, VesselID))
                setBatchDeleteBool(false);
                setPopOverIndex(0);
                setBDNObject({});
                setBDNFile([]);
                setCount(count + 1);
            }
        });
    };

    return (
        <React.Fragment>
            {(BunkeringObjectLoading) && <FormLoading />}
            {(BunkeringObjectError) && <ErrorComponent message='Error loading component' />}
            {(!BunkeringObjectLoading && !BunkeringObjectError) &&
                <Card className='p-0 mb-0 border-0'>
                    <CardHeader className="p-2">
                        <div className="text-center">
                            <Row>
                                <Col>
                                    <h4 className="page_title pos-start mb-0">BDN(s) Upload</h4>
                                    <p className="card-title-desc pos-start">
                                        All readings since last report
                                    </p>
                                </Col>
                                <Col>
                                    <ReportDetailsHeader />
                                </Col>
                            </Row>
                        </div>
                    </CardHeader>
                    <CardBody className='px-2'>
                        {!(BunkeringObjectLoading) && !(BunkeringObjectError) &&
                            <form autoComplete="off" onSubmit={BDNFormik.handleSubmit} noValidate key={count}>
                                <React.Fragment>
                                    <h5>Group bunkering operations for common BDN</h5>
                                    <p>(If you do not have scanned BDN to upload now, just proceed by clicking on "Next". BDNs can be uploaded later from the Dashboard.)</p>
                                    {Array.isArray(BDNFormik?.values?.bunkering)
                                        && BDNFormik?.values?.bunkering
                                        && BDNFormik?.values?.bunkering?.map((bunker: any, index: number) => {
                                            const selectedBunkeringIds = BDNFormik?.values.bunkering.flatMap((obj: any) => obj.bunkering) || [];
                                            return (
                                                <React.Fragment key={index}>
                                                    <Row className='min-height-6'>
                                                        <Col sm={5}>
                                                            <strong className='mb-0 me-2'>Select bunkers</strong>
                                                            <div id={`bunkering_${index}_bunkering`}>
                                                                <Select
                                                                    key={`${count}-${index}`}
                                                                    name={`bunkering.${index}.bunkering`}
                                                                    autoFocus={index === 0 ? true : false}
                                                                    className="label-w-20"
                                                                    options={BunkeringBDN.filter(
                                                                        (item: any) => !BDNFormik.values.bunkering
                                                                            .flatMap((b: any) => b.bunkering)
                                                                            .includes(item.bunkering) // filter using item.bunkering
                                                                    )}
                                                                    getOptionLabel={(e: any) => e.batch_name}
                                                                    getOptionValue={(e: any) => e.bunkering} // important: this must match what you store
                                                                    styles={customStyle}
                                                                    isMulti={true}
                                                                    isClearable={false}
                                                                    onBlur={() => BDNFormik.setFieldTouched(`bunkering.${index}.bunkering`, true)}
                                                                    onChange={(e: any, actionMeta: any) => {
                                                                        const matchedBunker = BunkeringBDN.find(
                                                                            (obj: any) => obj.bunkering === actionMeta?.removedValue?.bunkering
                                                                        );
                                                                        if (actionMeta.action === "remove-value" && matchedBunker?.bdn_file !== null) {
                                                                            setBatchDeleteBool(true);
                                                                            setPopOverIndex(index + 1);
                                                                            setBatchDeleteId(actionMeta?.removedValue?.id);
                                                                            setBDNObject(BDNFormik?.values?.bunkering[index]);
                                                                        }
                                                                        if (
                                                                            (e?.length === 0 && BDNFile[index]?.file) ||
                                                                            (e?.length === 0 && BDNFormik?.values?.bunkering[index]?.bdn_file !== null)
                                                                        ) {
                                                                            setDeleteUploadedFile(true);
                                                                            setDeleteBunkeringObject(bunker)
                                                                            setPopOverIndex(index + 1);
                                                                        }
                                                                        if (
                                                                            (e?.length > 0 || (e?.length === 0 && !BDNFile[index]?.file && BDNFormik?.values?.bunkering[index]?.bdn_file === null)) &&
                                                                            (actionMeta.action === "select-option" || (actionMeta.action === "remove-value" &&
                                                                                !BDNFormik?.initialValues?.bunkering[index]?.bunkering?.includes(actionMeta?.removedValue?.bunkering)))
                                                                        ) {
                                                                            BDNFormik?.setFieldValue(
                                                                                `bunkering.${index}.bunkering`,
                                                                                e.map((bunker: any) => bunker?.bunkering) // storing item.bunkering
                                                                            );
                                                                            setCount(count + 1);
                                                                        }
                                                                    }}
                                                                    value={
                                                                        BDNFormik?.values?.bunkering[index]?.bunkering?.length > 0 &&
                                                                        BDNFormik?.values?.bunkering[index]?.bunkering?.map((bunkId: any) => {
                                                                            const matchedItem = BunkeringBDN.find((item: any) => item.bunkering === bunkId);
                                                                            return matchedItem || null;
                                                                        }).filter(Boolean)
                                                                    }
                                                                />
                                                            </div>
                                                            {BDNFormik.errors?.bunkering
                                                                && BDNFormik?.touched?.bunkering && BDNFormik?.touched?.bunkering[index]?.bunkering &&
                                                                BDNFormik.errors?.bunkering[index]?.bunkering
                                                                && env?.form_validation === true && document.getElementById(`bunkering_${index}_bunkering`) !== null &&
                                                                !deleteUploadedFile &&
                                                                <ErrorTooltip
                                                                    target={`bunkering_${index}_bunkering`}
                                                                    message={BDNFormik.errors?.bunkering[index]?.bunkering}
                                                                    open={(BDNFormik.errors?.bunkering && BDNFormik.errors?.bunkering[index]?.bunkering) ? true : false}
                                                                />
                                                            }
                                                        </Col>
                                                        <Col>
                                                            {index !== undefined &&
                                                                <div className='m-0 p-0'>
                                                                    <ReportingFileUpload
                                                                        key={count}
                                                                        setFile={setBDNFile}
                                                                        file={BDNFile}
                                                                        fileUploadStatus={BDNFileObj[index]?.id}
                                                                        fileURL={BDNFileObj[index]?.file_name}
                                                                        deleteURL={`/bdn_file/`}
                                                                        // invalidateQuery={null}
                                                                        deleteID={BDNFileObj[index]?.id}
                                                                        refreshKey={count}
                                                                        setRefreshKey={setCount}
                                                                        title={''}
                                                                        DeleteFileObj={null}
                                                                        sm={4}
                                                                        index={index}
                                                                        isFileUploadDisable={bunker?.bunkering?.length === 0 || bunker.bunkering === null}
                                                                        fileRemoveKey={fileRemoveKey}
                                                                        setFileRemoveKey={setFileRemoveKey}
                                                                    />
                                                                </div>
                                                            }
                                                        </Col>
                                                        <Col sm={1} className='d-flex'>
                                                            {BDNFormik?.values?.bunkering?.length === 1 ? null : (
                                                                <React.Fragment>
                                                                    <button
                                                                        type="button"
                                                                        className="btn justify_right"
                                                                        id={`delete-button-${index}`}
                                                                    >
                                                                        <i
                                                                            className="dripicons-trash icon_s18"
                                                                            onClick={() => {
                                                                                setPopoverOpen(true);
                                                                                setPopOverIndex(index + 1);
                                                                                setDeleteBunkeringObject(bunker)
                                                                            }}
                                                                            onBlur={(e: any) => { BDNFormik?.handleBlur(e); }}
                                                                        />
                                                                    </button>
                                                                </React.Fragment>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    {
                                                        index === (BDNFormik?.values.bunkering.length - 1) && BunkeringBDN?.length > 1 &&
                                                        BDNFormik?.values.bunkering.length < BunkeringBDN?.length && selectedBunkeringIds.length < BunkeringBDN?.length &&
                                                        <Col>
                                                            <Label
                                                                className="link_color_blue pointer mt-2"
                                                                style={{ position: 'relative' }}
                                                                onClick={() => {
                                                                    let arr = [...BDNFormik?.values?.bunkering];
                                                                    arr.push({
                                                                        bdn_file: null,
                                                                        file_name: "",
                                                                        bunkering: [],
                                                                        vessel_reporting_information: ReportID
                                                                    });
                                                                    BDNFormik?.setFieldValue("bunkering", arr)
                                                                    const addEmptyBDNObject = [...BDNFile, {}]
                                                                    setBDNFile(addEmptyBDNObject)
                                                                }}
                                                            >
                                                                Add another BDN file
                                                            </Label>
                                                        </Col>
                                                    }
                                                </React.Fragment>
                                            )
                                        })}
                                    {popoverOpen &&
                                        <DeletePopOver
                                            target={`delete-button-${popOverIndex - 1}`}
                                            state={popoverOpen}
                                            setState={setPopoverOpen}
                                            onClick={() => {
                                                setPopoverOpen(false);
                                                deleteFileUploadItem(false, popOverIndex - 1, true)
                                                BDNFormik?.values?.bunkering.splice(popOverIndex - 1, 1);
                                                BDNFormik?.setFieldError(`bunkering.${popOverIndex - 1}`, null);
                                            }}
                                        />
                                    }
                                    {deleteUploadedFile && document.getElementById(`bunkering_${popOverIndex - 1}_bunkering`) !== null && (
                                        <DeletePopOver
                                            target={`bunkering_${popOverIndex - 1}_bunkering`}
                                            state={deleteUploadedFile}
                                            setState={setDeleteUploadedFile}
                                            onClick={() => {
                                                // Remove the item after confirmation
                                                setDeleteUploadedFile(false);
                                                deleteFileUploadItem(true, popOverIndex - 1);
                                                BDNFormik?.setFieldValue(`bunkering.${popOverIndex - 1}.bunkering`, null);
                                            }}
                                            message="Would you also like to delete the attached file?"
                                            noClick={() => {
                                                // If "No" is clicked, just reset the selection
                                                BDNFormik?.setFieldValue(`bunkering.${popOverIndex - 1}.bunkering`, null);
                                            }}
                                        />
                                    )}
                                    {batchDeleteBool && (popOverIndex - 1 >= 0) &&
                                        <DeletePopOver
                                            state={batchDeleteBool}
                                            setState={setBatchDeleteBool}
                                            target={`bunkering_${popOverIndex - 1}_bunkering`}
                                            onClick={async () => {
                                                if (batchDeleteId) {
                                                    await deleteSelectedBatch();
                                                }
                                            }}
                                            message={BDNObject?.bunkering?.length === 1 ? `If you delete this batch the BDN file will also be Deleted ` : `Are you sure you want to delete this batch?`}
                                        />
                                    }
                                </React.Fragment>
                                <CardFooter className='p-2 py-3'>
                                    {modalState ?
                                        <Row className="ele_row1">
                                            <Col sm={{ size: 2, offset: 10 }}>
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className='btn_size_cstm pos-end'
                                                    disabled={BDNFormik?.isSubmitting || !saveButtonDisableBool}
                                                >
                                                    {BDNFormik?.isSubmitting && <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />}
                                                    Save
                                                </Button>
                                            </Col>
                                        </Row> :
                                        <Row className="ele_row1">
                                            <div className="d-flex flex-wrap gap-5">
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    className='btn_size_cstm pos-end'
                                                    disabled={BDNFormik?.isSubmitting}
                                                >
                                                    {BDNFormik?.isSubmitting && <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />}
                                                    Next <i className="bx bx-chevron-right ms-1" />
                                                </Button>
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    className="btn_size_cstm"
                                                    onClick={() => {
                                                        setErrorMessage(null)
                                                        toggleDynamicTabs(previousEnggTabIndex - 1);
                                                        BDNFormik.setErrors({});
                                                    }
                                                    }
                                                >
                                                    <i className="bx bx-chevron-left me-1"
                                                        onClick={() => setErrorMessage(null)}
                                                    /> Previous</Button>
                                            </div>
                                        </Row>
                                    }
                                </CardFooter>
                                <div className='mt-4'>
                                    <FormValuesDebug values={[BDNFormik?.values, BDNFormik?.errors, BDNFormik.touched, BDNFormik?.initialValues]} />
                                </div>
                            </form>
                        }
                    </CardBody>
                </Card >
            }
        </React.Fragment >
    )
}

export default BunkeringFileUpload